import {
  GET_SUBSCRIPTION_USER_SUCCESS,
  GET_SUBSCRIPTION_USER_FAILED,
  IS_LOADING_GET_SUBSCRIPTION_USER,
  CREATE_SUBSCRIPTION_USER_SUCCESS,
  CREATE_SUBSCRIPTION_USER_FAILED,
  IS_LOADING_CREATE_SUBSCRIPTION_USER,
  GET_SUBSCRIPTION_SUCCESS,
  GET_SUBSCRIPTION_FAILED,
  IS_LOADING_GET_SUBSCRIPTION,
  MAKE_HASH_SUCCESS,
  MAKE_HASH_FAILED,
  CREATE_NEW_PAYMENT_HISTORY_SUCCESS,
  CREATE_NEW_PAYMENT_HISTORY_FAILED,
  IS_LOADING_CREATE_NEW_PAYMENT_HISTORY,
  GET_ALL_PAYMENT_HISTORY_OF_COMPANY_SUCCESS,
  GET_ALL_PAYMENT_HISTORY_OF_COMPANY_FAILED,
  IS_LOADING_GET_ALL_PAYMENT_HISTORY_OF_COMPANY,
  UPDATE_SUBSCRIPTION_SUCCESS,
  UPDATE_SUBSCRIPTION_FAILED,
} from "../actions/types";

const initialState = {
  // - get subscription user - //
  isSubscriptionUserDetailsLoading: true,
  subscriptionUserId: null,
  subscriptionUserCompanyId: null,
  subscriptionUserActiveStatus: null,
  subscriptionUserFirstName: null,
  subscriptionUserLastName: null,
  subscriptionUserEmail: null,
  subscriptionUserAddress: null,
  subscriptionUserCity: null,
  subscriptionUserPhone: null,

  // - create subscription user - //
  isCreateSubscriptionUserLoading: true,

  // - get subscription - //
  isSubscriptionDetailsLoading: true,
  subscriptionId: null,
  subscriptionCompanyId: null,
  subscriptionActiveStatus: null,
  subscriptionIsRecurring: null,
  subscriptionCurrentPeriodStartAt: null,
  subscriptionCurrentPeriodEndAt: null,
  subscriptionPlanName: null,
  subscriptionPlanAmount: null,
  subscriptionPlanDescription: null,
  subscriptionPlanValueAddedPrice: null,
  subscriptionPlanServiceName: null,
  subascriptionCardHolderName: null,
  subscriptionCardNumber: null,
  subscriptionCardType: null,
  subscriptionCardExpiry: null,
  subscriptionIsRecurring: false,

  // - create subscription - //
  isCreateSubscriptionLoading: true,

  // - make hash - //
  isMakeHashLoading: true,
  hash: null,

  // - one time payment - //
  isOneTimePaymentLoading: true,

  // - subscription payment - //
  isSubscriptionPaymentLoading: true,

  // - get all subscription plans - //
  isGetAllSubscriptionPlansLoading: true,

  // - create new payment history - //
  isCreateNewPaymentHistoryLoading: true,

  // - get all payment history of company - //
  isGetAllPaymentHistoryOfCompanyLoading: true,
  paymentHistory: [],

  // - update subscription to another - //
  isUpdateSubscriptionLoading: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    // get subscription user
    case GET_SUBSCRIPTION_USER_SUCCESS:
      return {
        ...state,
        isSubscriptionUserDetailsLoading: false,
        subscriptionUserId: payload.id,
        subscriptionUserCompanyId: payload.companyId,
        subscriptionUserActiveStatus: payload.status,
        subscriptionUserFirstName: payload.firstName,
        subscriptionUserLastName: payload.lastName,
        subscriptionUserEmail: payload.email,
        subscriptionUserAddress: payload.address,
        subscriptionUserCity: payload.city,
        subscriptionUserPhone: payload.phone,
      };

    case GET_SUBSCRIPTION_USER_FAILED:
      return {
        ...state,
        isSubscriptionUserDetailsLoading: false,
        subscriptionUserId: null,
        subscriptionUserCompanyId: null,
        subscriptionUserActiveStatus: null,
        subscriptionUserFirstName: null,
        subscriptionUserLastName: null,
        subscriptionUserEmail: null,
        subscriptionUserAddress: null,
        subscriptionUserCity: null,
        subscriptionUserPhone: null,
      };

    case IS_LOADING_GET_SUBSCRIPTION_USER:
      return {
        ...state,
        isSubscriptionUserDetailsLoading: payload,
      };

    // create subscription user
    case CREATE_SUBSCRIPTION_USER_SUCCESS:
      return {
        ...state,
        isCreateSubscriptionUserLoading: false,
        subscriptionUserId: payload.id,
        subscriptionUserCompanyId: payload.companyId,
        subscriptionUserActiveStatus: payload.status,
        subscriptionUserFirstName: payload.firstName,
        subscriptionUserLastName: payload.lastName,
        subscriptionUserEmail: payload.email,
        subscriptionUserAddress: payload.address,
        subscriptionUserCity: payload.city,
        subscriptionUserPhone: payload.phone,
      };

    case CREATE_SUBSCRIPTION_USER_FAILED:
      return {
        ...state,
        isCreateSubscriptionUserLoading: false,
        subscriptionUserId: null,
        subscriptionUserCompanyId: null,
        subscriptionUserActiveStatus: null,
        subscriptionUserFirstName: null,
        subscriptionUserLastName: null,
        subscriptionUserEmail: null,
        subscriptionUserAddress: null,
        subscriptionUserCity: null,
        subscriptionUserPhone: null,
      };

    case IS_LOADING_CREATE_SUBSCRIPTION_USER:
      return {
        ...state,
        isSubscriptionUserDetailsLoading: payload,
      };

    // get subscription
    case GET_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        isSubscriptionDetailsLoading: false,
        subscriptionId: payload.id,
        subscriptionCompanyId: payload.companyId,
        subscriptionActiveStatus: payload.activeStatus,
        subscriptionIsRecurring: payload.isRecurring,
        subscriptionCurrentPeriodStartAt: payload.currentPeriodStartAt,
        subscriptionCurrentPeriodEndAt: payload.currentPeriodEndAt,
        subscriptionPlanName: payload.plan.name,
        subscriptionPlanAmount: payload.plan.amount,
        subscriptionPlanDescription: payload.plan.description,
        subscriptionPlanValueAddedPrice: payload.plan.valueAddedPrice,
        subscriptionPlanServiceName: payload.serviceName,
        subascriptionCardHolderName: payload.card.cardHolderName,
        subscriptionCardNumber: payload.card.cardNumber,
        subscriptionCardType: payload.card.cardType,
        subscriptionCardExpiry: payload.card.cardExpire,
        subscriptionIsRecurring: payload.isRecurring,
      };

    case GET_SUBSCRIPTION_FAILED:
      return {
        ...state,
        isSubscriptionDetailsLoading: false,
        subscriptionId: null,
        subscriptionCompanyId: null,
        subscriptionActiveStatus: null,
        subscriptionIsRecurring: null,
        subscriptionCurrentPeriodStartAt: null,
        subscriptionCurrentPeriodEndAt: null,
        subscriptionPlanName: null,
        subscriptionPlanAmount: null,
        subscriptionPlanDescription: null,
        subscriptionPlanValueAddedPrice: null,
        subscriptionPlanServiceName: null,
        subascriptionCardHolderName: null,
        subscriptionCardNumber: null,
        subscriptionCardType: null,
        subscriptionCardExpiry: null,
        subscriptionIsRecurring: false,
      };

    case IS_LOADING_GET_SUBSCRIPTION:
      return {
        ...state,
        isSubscriptionDetailsLoading: payload,
      };

    // make hash
    case MAKE_HASH_SUCCESS:
      return {
        ...state,
        isMakeHashLoading: false,
        hash: payload,
      };

    case MAKE_HASH_FAILED:
      return {
        ...state,
        isMakeHashLoading: false,
        hash: null,
      };

    // create new payment history
    case CREATE_NEW_PAYMENT_HISTORY_SUCCESS:
      return {
        ...state,
        isCreateNewPaymentHistoryLoading: false,
      };

    case CREATE_NEW_PAYMENT_HISTORY_FAILED:
      return {
        ...state,
        isCreateNewPaymentHistorySuccess: false,
      };

    case IS_LOADING_CREATE_NEW_PAYMENT_HISTORY:
      return {
        ...state,
        isCreateNewPaymentHistoryLoading: payload,
      };

    // get all payment history of company
    case GET_ALL_PAYMENT_HISTORY_OF_COMPANY_SUCCESS:
      return {
        ...state,
        isGetAllPaymentHistoryOfCompanyLoading: false,
        paymentHistory: payload,
      };

    case GET_ALL_PAYMENT_HISTORY_OF_COMPANY_FAILED:
      return {
        ...state,
        isGetAllPaymentHistoryOfCompanyLoading: false,
        paymentHistory: null,
      };

    case IS_LOADING_GET_ALL_PAYMENT_HISTORY_OF_COMPANY:
      return {
        ...state,
        isGetAllPaymentHistoryOfCompanyLoading: payload,
      };

    // update subscription to another
    case UPDATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        isUpdateSubscriptionLoading: false,
      };

    case UPDATE_SUBSCRIPTION_FAILED:
      return {
        ...state,
        isUpdateSubscriptionLoading: false,
      };

    default:
      return state;
  }
}
